import React from "react";
import { Card, CardHeader, CardBody, Table } from "reactstrap";
import { useTranslation } from "react-i18next";

const RightSection = ({ job }) => {
  const { t } = useTranslation();

  return (
      <React.Fragment>
        <Card>
          <CardHeader>
            <h5 className="mb-0">{t("job_overview.right_section.title")}</h5>
          </CardHeader>
          <CardBody>
            <div className="table-responsive table-card">
              <Table className="table mb-0">
                <tbody>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.title_label")}</td>
                  <td>{job.jobTitle}</td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.company_name")}</td>
                  <td>{job.company}</td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.location")}</td>
                  <td>{job.country}, {job.state}</td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.time")}</td>
                  <td>
                    <span
                        className={`badge badge-soft-${
                            job.jobType === "Full-Time"
                                ? "success"
                                : job.jobType === "Part-Time"
                                    ? "info"
                                    : job.jobType === "Internship"
                                        ? "warning"
                                        : "primary"
                        }`}
                    >
                      {job.jobType}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.job_applications")}</td>
                  <td>{job.candidateCount || 0}</td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.post_date")}</td>
                  <td>{new Date(job.datePublication).toLocaleDateString()}</td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.salary")}</td>
                 <td>
                   {job.startSalary && job.lastSalary
                       ? `Salary Range: ${job.startSalary} - ${job.lastSalary}`
                       : "Salary Not Available"}
                 </td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.experience")}</td>
                  <td>{job.experienceYears || t("job_overview.right_section.experience_na")}</td>
                </tr>
                <tr>
                  <td className="fw-medium">{t("job_overview.right_section.qualification")}</td>
                  <td>{job.qualification || t("job_overview.right_section.qualification_not_specified")}</td>
                </tr>
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
  );
};

export default RightSection;